import cn from 'classnames';
import Breadcrumb from 'components/Breadcrumb';
import Button from 'components/Button';
import Label from 'components/Label';
import { Heading, P, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import { signUpUrl } from 'utils/config';
import { contentWrapper, headingC, imageBg, imageC, item, itemImage, root, wrapper as wrapperC } from './FeatureBanner.module.scss';

const FeatureBanner = ({ data: { heading, content, img, isNew, cta, imageAsBg }, breadcrumb }) => (
  <section className={wrapperC}>
    <Wrapper size="L" className={root}>
      <div className={item}>
        <div className={contentWrapper}>
          <Breadcrumb links={breadcrumb} />
          <Heading Tag="h1" bold marginBottom="S" className={headingC}>
          {isNew && <Label text="New" theme="Yellow" position="before" />}{heading}</Heading>
          <P Tag="h2" size="L" marginBottom="S">{content}</P>
          { cta ?
          <Button href={cta.url}
          size="L"
          type="nlGradient"
          text={cta.text} openNew={cta.openNew} />
          : <Button href={signUpUrl}
          size="L"
          type="nlGradient"
          text="免費試用" />
          }
        </div>
      </div>
      { imageAsBg ?
      <div
        style={{ backgroundImage: `url(${img.publicURL})`}}
        className={cn(item, imageBg)}
      ></div>
      : <div className={cn(item, itemImage)}>
        <img src={img.publicURL}  alt={heading} className={imageC} />
      </div> }
    </Wrapper>
  </section>
);

FeatureBanner.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    img: PropTypes.shape({
      publicURL: PropTypes.string.isRequired,
    }),
    imageAsBg: PropTypes.bool,
    isNew: PropTypes.bool,
    cta: PropTypes.shape({
      url: PropTypes.string,
      text: PropTypes.string,
      openNew: PropTypes.bool,
    })
  }),
  breadcrumb: PropTypes.arrayOf(PropTypes.shape({
    link: PropTypes.string,
    text: PropTypes.string
  }))
}

export default FeatureBanner;